import { Flex, Typography } from '@percent/lemonade'

type ConfigSectionProps = {
  title: string
  children: React.ReactNode
}

export function ConfigSection({ title, children }: ConfigSectionProps) {
  return (
    <Flex direction="column" gap="m">
      <Typography variant="h4">{title}</Typography>
      <Flex direction="column" gap="xs">
        {children}
      </Flex>
    </Flex>
  )
}
